import * as React from "react";
const SelectBoxIcon2 = (props) => (
  <svg
    width={14}
    height={7}
    viewBox="0 0 14 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.740952 1.31367L6.49988 6.7222C6.59271 6.80933 6.70786 6.87927 6.83743 6.92722C6.967 6.97517 7.10793 7 7.25054 7C7.39316 7 7.53409 6.97517 7.66366 6.92722C7.79323 6.87927 7.90838 6.80933 8.00121 6.7222L13.7601 1.31367C14.3097 0.797419 13.8541 0 13.0095 0H1.48997C0.645368 0 0.189697 0.797419 0.740952 1.31367Z"
      fill="#00C1B2"
    />
  </svg>
);
export default SelectBoxIcon2;
